import React from 'react'

import { niceJoin } from '../../lib/formats'
import DataGrid from '../UI/DataGrid'
import ClientCard from './ClientCard'

const ListClients = () => {
  const gridColumns = [
    { name: 'id', title: 'ID' },
    { name: 'name', title: 'Name' },
    { name: 'phone', title: 'Phone' },
    { name: 'address', title: 'Address' },
    { name: 'location', title: 'Location' }
  ]

  const gridRowMappingFn = client => {
    const id = client.id
    const { name, phone, address, city, province, country } = client.attributes

    return {
      id: id,
      name: name,
      phone: phone,
      address: address,
      location: niceJoin([city, province, country], ', ', 'N/A')
    }
  }

  const gridSorting = [{ columnName: 'name', direction: 'asc' }]
  const gridHiddenColumns = ['id']
  const tableColumnVisibilityExtensions = [
    { columnName: 'id', togglingEnabled: false },
    { columnName: 'name', togglingEnabled: false }
  ]

  return (
    <DataGrid
      resourceAPIEndpoint="clients"
      resourceSingularName="client"
      resourcePluralName="clients"
      nameAttribute="name"
      clientRootPath="/clients"
      gridColumns={gridColumns}
      gridRowMappingFn={gridRowMappingFn}
      gridSorting={gridSorting}
      gridHiddenColumns={gridHiddenColumns}
      tableColumnVisibilityExtensions={tableColumnVisibilityExtensions}
      detailsCard={ClientCard}
    />
  )
}

export default ListClients



// WEBPACK FOOTER //
// ./src/components/Clients/ListClients.jsx